<template>
  <a-drawer
    :title="title"
    width="60%"
    :visible="visible"
    :body-style="{ paddingBottom: '80px' }"
    @close="onClose"
  >
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <!-- 基本信息 -->
        <a-descriptions title="基本信息" :column="2" bordered>
          <a-descriptions-item label="套餐ID">{{ detailData.id || '-' }}</a-descriptions-item>
          <a-descriptions-item label="套餐名称">{{ detailData.packageName || '-' }}</a-descriptions-item>
          <a-descriptions-item label="短信数量">{{ detailData.smsCount ? `${detailData.smsCount}条` : '-' }}</a-descriptions-item>
          <a-descriptions-item label="套餐价格">¥{{ formatAmount(detailData.price) }}</a-descriptions-item>
          <a-descriptions-item label="单价">¥{{ formatAmount(detailData.unitPrice) }}</a-descriptions-item>
          <a-descriptions-item label="有效期">{{ getValidDaysText(detailData.validDays) }}</a-descriptions-item>
          <a-descriptions-item label="通道类型">
            <a-tag :color="getChannelTypeColor(detailData.channelType)">
              {{ getChannelTypeText(detailData.channelType) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="短信类型">
            <a-tag :color="getSmsTypeColor(detailData.smsType)">
              {{ getSmsTypeText(detailData.smsType) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="状态">
            <a-tag :color="getStatusColor(detailData.status)">
              {{ getStatusText(detailData.status) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="排序号">{{ detailData.sort || '-' }}</a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ formatTime(detailData.createTime) }}</a-descriptions-item>
        </a-descriptions>

        <!-- 描述信息 -->
        <a-descriptions title="描述信息" :column="1" bordered style="margin-top: 16px">
          <a-descriptions-item label="套餐描述">{{ detailData.description || '无描述' }}</a-descriptions-item>
          <a-descriptions-item label="备注">{{ detailData.remark || '无备注' }}</a-descriptions-item>
        </a-descriptions>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="onClose">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getObj } from '@/api/sms/package'
import moment from 'moment'

export default {
  name: 'DetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      title: '套餐详情',
      detailData: {},
    }
  },
  methods: {
    show(record) {
      this.visible = true
      this.title = `套餐详情`
      this.loadDetail(record.id)
    },

    hide() {
      this.visible = false
      this.detailData = {}
    },

    onClose() {
      this.hide()
    },

    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getObj(id)
        if (response.success) {
          this.detailData = response.data || {}
        } else {
          this.$message.error('加载详情失败')
        }
      } catch (error) {
        console.error('加载套餐详情失败:', error)
        this.$message.error('加载套餐详情失败')
      } finally {
        this.loading = false
      }
    },

    // 格式化金额显示
    formatAmount(amount) {
      if (!amount && amount !== 0) return '0.00'
      return parseFloat(amount).toFixed(2)
    },

    // 格式化时间显示
    formatTime(time) {
      if (!time) return '-'
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },

    // 获取有效期文本
    getValidDaysText(validDays) {
      if (!validDays && validDays !== 0) return '-'
      return validDays === 0 ? '永久有效' : `${validDays}天`
    },

    // 通道类型相关方法
    getChannelTypeText(type) {
      const typeMap = {
        1: '国内通道',
        2: '国际通道',
        3: '应急通道',
      }
      return typeMap[type] || '-'
    },

    getChannelTypeColor(type) {
      const colorMap = {
        1: 'green',
        2: 'blue',
        3: 'orange',
      }
      return colorMap[type] || 'default'
    },

    // 短信类型相关方法
    getSmsTypeText(type) {
      const typeMap = {
        1: '普通短信',
        2: '营销短信',
        3: '国际短信',
      }
      return typeMap[type] || '-'
    },

    getSmsTypeColor(type) {
      const colorMap = {
        1: 'blue',
        2: 'green',
        3: 'orange',
      }
      return colorMap[type] || 'default'
    },

    // 状态相关方法
    getStatusText(status) {
      const statusMap = {
        0: '禁用',
        1: '启用',
      }
      return statusMap[status] || '-'
    },

    getStatusColor(status) {
      const colorMap = {
        0: 'red',
        1: 'green',
      }
      return colorMap[status] || 'default'
    },
  },
}
</script>

<style scoped>
.drawer-content {
  padding: 0;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.ant-descriptions {
  margin-bottom: 0;
}

/* 确保label不换行 */
.ant-descriptions-item-label {
  white-space: nowrap;
  min-width: 90px;
  text-align: right;
  padding-right: 8px;
}
</style>
